import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { database } from 'firebase';
import { LoaderService } from 'src/app/shared/services/loader-service';

@Component({
  selector: 'app-takeaway',
  templateUrl: './takeaway.component.html',
  styleUrls: ['./takeaway.component.scss']
})
export class TakeawayComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<TakeawayComponent>,private loader:LoaderService) { }
  private now: boolean = true;
  approvedNow=true;
  houres: string[] = [ ];
  error: string;
  selectedHour: string;
  selectedBranch: string;
  branches: string[];
  date:Date=new Date;
  ngOnInit() {
    this.branches = this.data;
    this.selectedBranch=this.branches[0];
    this.getHours()
  }

  choosenNow(event) {
    this.now = event;
  }

  getHours(){
    const hour=new Date().getHours();
    const placeInfo=this.loader.getCustomer();
    let taOpenTime= placeInfo.taOpenTime;
    const taCloseTime= placeInfo.taCloseTime;
    console.log("now = " + hour)
    console.log("open = " + taOpenTime)
    console.log("close = " + taCloseTime)
    if (taOpenTime > hour || hour >= taCloseTime){
      this.approvedNow=false;
    }
    if (taOpenTime<hour)
    {
      taOpenTime=hour+1;
    }
    for (let index = 0; index < taCloseTime-taOpenTime; index++) {
        this.houres.push((taOpenTime+index).toString()+ ":00")
        this.houres.push((taOpenTime+index).toString()+ ":15")
        this.houres.push((taOpenTime+index).toString()+ ":30")
        this.houres.push((taOpenTime+index).toString()+ ":45")
      
    }
    console.log("date",this.date.getHours());
    console.log("placeInfo",placeInfo);

  }

  submit() {
    this.error = null;
    if (!this.now && !this.selectedHour) {
      this.error = "אנא בחר שעה"
      return;
    }
    if (!this.selectedBranch) {
      this.error = "אנא בחר סניף"
      return;
    }
    if (!this.approvedNow&&this.now){
      this.error = "המסעדה פתוחה להזמנות עתידיות בלבד"
      return;
    }
    this.dialogRef.close({ "branch": this.selectedBranch, "now": this.now, "hour": this.selectedHour });
  }

  changeToDelivery() {
    this.dialogRef.close({ "delivery": true });
  }

}
